import AvanttiLogo from '../components/icons/AvanttiLogo';

const OnBoardingScreens: JSX.Element[] = [
  <div className="flex flex-col gap-4 justify-between items-center px-4 text-text-primary min-h-[60vh] max-h-[60vh] md:min-h-[50vh] md:max-h-[50vh]">
    <AvanttiLogo className="w-28 h-28 mt-4" />
    <div className="flex flex-row gap-6 justify-center items-center">
      <img src="/music-note-01.svg" alt="" />
      <img src="/lucide-lab_burger.svg" alt="" />
      <img src="/tabler_masks-theater.svg" alt="" />
    </div>
    <div className="flex flex-col gap-4 justify-center items-center mb-8">
      <h1 className="text-3xl font-bold text-center">¡Te damos la bienvenida a Avantti!</h1>
      <p className="text-2xl text-center">Gestioná tus eventos de forma fácil, cómoda y recibí el dinero mucho antes.</p>
    </div>
  </div>,
  <div className="flex flex-col gap-4 justify-between items-center px-4 text-text-primary min-h-[60vh] max-h-[60vh] md:min-h-[50vh] md:max-h-[50vh]">
    <div className="flex flex-col gap-4 justify-center items-center mt-8">
      <h1 className="text-3xl text-center">Creá tu evento en minutos</h1>
      <p className="text-xl text-center">Interfaz simple e intuitiva para configurar tu evento en pocos pasos, sin complicaciones.</p>
    </div>
    <div className="w-full flex justify-center">
      <img src="/onBoarding-1.svg" alt="" className="max-w-full h-auto max-h-[30vh]" />
    </div>
  </div>,
  <div className="flex flex-col gap-4 justify-between items-center px-4 text-text-primary min-h-[60vh] max-h-[60vh] md:min-h-[50vh] md:max-h-[50vh]">
    <div className="flex flex-col gap-4 justify-center items-center mt-8">
      <h1 className="text-3xl text-center">Cobrá en el momento</h1>
      <p className="text-xl text-center">Recibí el dinero de tus entradas de forma instantánea. En el momento que hiciste una venta ya podes solicitar la transferencia, sin demoras, porque ese dinero: es tuyo.</p>
    </div>
    <div className="w-full flex justify-center">
      <img src="/onBoarding-2.svg" alt="" className="max-w-full h-auto max-h-[30vh]" />
    </div>
  </div>,
  <div className="flex flex-col gap-4 justify-between items-center px-4 text-text-primary min-h-[60vh] max-h-[60vh] md:min-h-[50vh] md:max-h-[50vh]">
    <div className="flex flex-col gap-4 justify-center items-center mt-8">
      <h1 className="text-3xl text-center">Vendé donde quieras</h1>
      <p className="text-xl text-center">Ofrecé entradas online, a través de vendedores o de forma presencial, y generá links de difusión personalizados para ampliar tus ventas.</p>
    </div>
    <div className="w-full flex justify-center">
      <img src="/onBoarding-3.svg" alt="" className="max-w-full h-auto max-h-[30vh]" />
    </div>
  </div>,
  <div className="flex flex-col gap-4 justify-between items-center px-4 text-text-primary min-h-[60vh] max-h-[60vh] md:min-h-[50vh] md:max-h-[50vh]">
    <div className="flex flex-col gap-4 justify-center items-center mt-8">
      <h1 className="text-3xl text-center">Gestioná todo en un solo lugar</h1>
      <p className="text-xl text-center">Entradas vendidas e invitados sin cargo centralizados en una sola plataforma, con control de accesos mediante escaneo QR integrado.</p>
    </div>
    <div className="w-full flex justify-center">
      <img src="/onBoarding-4.svg" alt="" className="max-w-full h-auto max-h-[30vh]" />
    </div>
  </div>,
];

export default OnBoardingScreens;
